const messages = {
  en: {
    translations: {
      signup: {
        title: "Sign up",
        toasts: {
          success: "User created successfully! Please login!",
          fail: "Error creating user. Check the reported data.",
        },
        form: {
          name: "Name",
          email: "Email",
          password: "Password",
        },
        buttons: {
          submit: "Register",
          login: "Already have an account? Log in!",
        },
      },
      login: {
        title: "Login",
        form: {
          email: "Email",
          password: "Password",
        },
        buttons: {
          submit: "Enter",
          register: "Don't have an account? Register!",
        },
      },
      auth: {
        toasts: {
          success: "Login successfully!",
        },
      },
      dashboard: {
        charts: {
          perDay: {
            title: "Tickets today: ",
          },
        },
        messages: {
          inAttendance: {
            title: "In Service"
          },
          waiting: {
            title: "Waiting"
          },
          closed: {
            title: "Closed"
          }
        }
      },
      connections: {
        title: "Connections",
        toasts: {
          deleted: "WhatsApp connection deleted sucessfully!",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage: "Are you sure? It cannot be reverted.",
          disconnectTitle: "Disconnect",
          disconnectMessage: "Are you sure? You'll need to read QR Code again.",
        },
        buttons: {
          add: "Add WhatsApp",
          disconnect: "Disconnect",
          tryAgain: "Try Again",
          qrcode: "QR CODE",
          newQr: "New QR CODE",
          connecting: "Connectiing",
        },
        toolTips: {
          disconnected: {
            title: "Failed to start WhatsApp session",
            content:
              "Make sure your cell phone is connected to the internet and try again, or request a new QR Code",
          },
          qrcode: {
            title: "Waiting for QR Code read",
            content:
              "Click on 'QR CODE' button and read the QR Code with your cell phone to start session",
          },
          connected: {
            title: "Connection established",
          },
          timeout: {
            title: "Connection with cell phone has been lost",
            content:
              "Make sure your cell phone is connected to the internet and WhatsApp is open, or click on 'Disconnect' button to get a new QRcode",
          },
        },
        table: {
          name: "Name",
          status: "Status",
          lastUpdate: "Last Update",
          default: "Default",
          actions: "Actions",
          session: "Session",
        },
      },
      whatsappModal: {
        title: {
          add: "Add WhatsApp",
          edit: "Edit WhatsApp",
        },
        form: {
          name: "Name",
          default: "Default",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        success: "WhatsApp saved successfully.",
      },
      qrCode: {
        message: "Read QrCode to start the session",
      },
      contacts: {
        title: "Contacts",
        toasts: {
          deleted: "Contact deleted sucessfully!",
        },
        searchPlaceholder: "Search ...",
        tagFilterLabel: "Tag",
        tagFilterAll: "All",
        confirmationModal: {
          deleteTitle: "Delete",
          importTitlte: "Import contacts",
          deleteMessage:
            "Are you sure you want to delete this contact? All related tickets will be lost.",
          importMessage: "Do you want to import all contacts from the phone?",
        },
        buttons: {
          import: "Import Contacts",
          add: "Add Contact",
        },
        table: {
          name: "Name",
          whatsapp: "WhatsApp",
          email: "Email",
          document: "Code",
          tags: "Tags",
          actions: "Actions",
        },
      },
      contactModal: {
        title: {
          add: "Add contact",
          edit: "Edit contact",
        },
        form: {
          mainInfo: "Contact details",
          extraInfo: "Additional information",
          name: "Name",
          number: "Whatsapp number",
          email: "Email",
          documents: "Codes (RUC/DNI/CE)",
          document: "Code",
          extraName: "Field name",
          extraValue: "Value",
        },
        buttons: {
          addExtraInfo: "Add information",
          addDocument: "Add code",
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        success: "Contact saved successfully.",
      },
      quickAnswersModal: {
        title: {
          add: "Add Quick Reply",
          edit: "Edit Quick Answer",
        },
        form: {
          shortcut: "Shortcut",
          message: "Quick Reply",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        success: "Quick Reply saved successfully.",
      },
      autoReplyRuleModal: {
        title: {
          add: "Add automation",
          edit: "Edit automation",
        },
        form: {
          name: "Rule name",
          whatsapp: "Connection",
          matchType: "Trigger condition",
          matchTypeKeywords: "Keywords",
          matchTypeAny: "Any message",
          keywords: "Keywords",
          keywordsHelper:
            "Comma separated. All of them must appear in the message to trigger the rule.",
          quickAnswer: "Quick answer to send",
          media: "Attachment",
          mediaHelper:
            "Optional. Image, PDF or other file sent along with the reply.",
          mediaUpload: "Upload file",
          mediaUploading: "Uploading...",
          mediaOrder: "Send order",
          mediaOrderMediaFirst: "Attachment first",
          mediaOrderTextFirst: "Text first",
          parentRule: "Parent rule",
          parentRuleNone: "None (root rule)",
          parentRuleHelper:
            "If you pick a parent rule, this one only triggers when the last automated reply sent to the customer was that rule — useful for building a multi-step conversation.",
          priority: "Priority",
          priorityHelper:
            "If several active rules match, the lowest number wins.",
          tagFilter: "Tag audience",
          tagFilterAll: "All contacts",
          tagFilterWithTag: "Only contacts with a tag",
          tagFilterWithoutTag: "Only contacts without a tag",
          active: "Active",
          windows: {
            title: "Schedule restriction",
            helper:
              "If you don't add any window, the rule will always be active.",
            add: "+ Add schedule window",
            type: "Window type",
            typeWeekly: "Weekly",
            typeDate: "Specific date",
            startTime: "Start time",
            endTime: "End time",
            endDayOffset: "Ends N day(s) later",
            endDayOffsetHelper:
              "0 = same day, 1 = next day, 2 = two days later (e.g. Saturday to Monday).",
            date: "Date",
            allDay: "All day",
            days: {
              mon: "Mon",
              tue: "Tue",
              wed: "Wed",
              thu: "Thu",
              fri: "Fri",
              sat: "Sat",
              sun: "Sun",
            },
          },
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        success: "Automation saved successfully.",
      },
      autoReplyRules: {
        title: "Automations",
        table: {
          name: "Name",
          whatsapp: "Connection",
          keywords: "Keywords",
          matchTypeAny: "Any message",
          quickAnswer: "Answer",
          dependsOn: "Depends on",
          active: "Active",
          actions: "Actions",
        },
        buttons: {
          add: "Add automation",
        },
        toasts: {
          deleted: "Automation deleted successfully",
        },
        confirmationModal: {
          deleteTitle: "Are you sure you want to delete the automation",
          deleteMessage: "This action cannot be undone.",
        },
      },
      autoReplyFlowModal: {
        title: {
          add: "Add advanced automation",
          edit: "Edit advanced automation",
        },
        helper:
          "For multi-step replies (text, image, audio, video...) sent all at once when triggered, without waiting for the customer to reply in between.",
        form: {
          name: "Rule name",
          whatsapp: "Connection",
          matchType: "Trigger condition",
          matchTypeKeywords: "Keywords",
          matchTypeAny: "Any message",
          keywords: "Keywords",
          keywordsHelper:
            "Comma-separated. All must appear in the message to trigger the rule.",
          parentRule: "Parent rule",
          parentRuleNone: "None (root rule)",
          parentRuleHelper:
            "If you pick a parent rule, this one only triggers when the last automatic reply sent to the customer was that rule (simple or advanced) — use it to chain steps of a conversation.",
          priority: "Priority",
          priorityHelper:
            "If several active rules match, the lowest number wins.",
          tagFilter: "Audience by tag",
          tagFilterAll: "All customers",
          tagFilterWithTag: "Only customers with a tag",
          tagFilterWithoutTag: "Only customers without a tag",
          active: "Active",
          windows: {
            title: "Schedule restriction",
            helper: "If you don't add any window, the rule is always active.",
            add: "+ Add schedule window",
            type: "Window type",
            typeWeekly: "Weekly",
            typeDate: "Specific date",
            startTime: "Start time",
            endTime: "End time",
            endDayOffset: "Ends N day(s) later",
            endDayOffsetHelper:
              "0 = same day, 1 = next day, 2 = two days later (e.g. Saturday to Monday).",
            date: "Date",
            allDay: "All day",
            days: {
              mon: "Mon",
              tue: "Tue",
              wed: "Wed",
              thu: "Thu",
              fri: "Fri",
              sat: "Sat",
              sun: "Sun",
            },
          },
          steps: {
            title: "Step sequence",
            helper: "Sent in this order, one by one, with a short pause between each.",
            empty: "No steps added yet.",
            add: "+ Add step",
            type: "Step type",
            typeText: "Text",
            typeImage: "Image",
            typeVideo: "Video",
            typeAudio: "Audio (voice note)",
            typeDocument: "Document",
            textPlaceholder: "Write this step's message...",
            mediaUpload: "Upload file",
            mediaUploading: "Uploading...",
            mediaChange: "Change file",
          },
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        success: "Advanced automation saved successfully.",
      },
      autoReplyFlows: {
        title: "Advanced Automations",
        table: {
          name: "Name",
          whatsapp: "Connection",
          keywords: "Keywords",
          matchTypeAny: "Any message",
          steps: "Steps",
          dependsOn: "Depends on",
          active: "Active",
          actions: "Actions",
        },
        buttons: {
          add: "Add advanced automation",
        },
        toasts: {
          deleted: "Advanced automation deleted successfully",
        },
        confirmationModal: {
          deleteTitle: "Are you sure you want to delete the advanced automation",
          deleteMessage: "This action cannot be undone.",
        },
      },
      followUpRuleModal: {
        helper:
          "Sends an automatic reminder when a prospect (no tag) stops responding after you wrote to them.",
        title: {
          add: "Add follow-up reminder",
          edit: "Edit follow-up reminder",
        },
        form: {
          name: "Rule name",
          whatsapp: "Connection",
          funnelStage: "Funnel stage",
          funnelStageAny: "Any stage",
          reminderSection: "Reminder (customer silence after your message)",
          hoursThreshold: "Hours of silence before reminding",
          hoursThresholdHelper:
            "Triggers when this many hours pass since your last message without the customer replying.",
          quickAnswer: "Quick answer to send",
          resolveSection: "Auto-resolve (customer silence)",
          resolveHelper:
            "Optional. This action happens once the configured time has passed since the last time the customer wrote or interacted, no matter how many times you've replied since then. Leave empty to disable this part.",
          resolveAfterClientHours: "Hours of silence before resolving",
          resolveAfterClientHoursPlaceholder: "E.g. 48 (empty = disabled)",
          active: "Active",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        success: "Reminder saved successfully.",
      },
      followUpRules: {
        title: "Follow-up",
        table: {
          name: "Name",
          whatsapp: "Connection",
          funnelStage: "Stage",
          hoursThreshold: "Reminder",
          resolveAfterClientHours: "Auto-resolve",
          quickAnswer: "Answer",
          active: "Active",
          actions: "Actions",
        },
        buttons: {
          add: "Add reminder",
        },
        toasts: {
          deleted: "Reminder deleted successfully",
        },
        confirmationModal: {
          deleteTitle: "Are you sure you want to delete the reminder",
          deleteMessage: "This action cannot be undone.",
        },
      },
      queueModal: {
        title: {
          add: "Add queue",
          edit: "Edit queue",
        },
        form: {
          name: "Name",
          color: "Color",
          greetingMessage: "Greeting Message",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
      },
      userModal: {
        title: {
          add: "Add user",
          edit: "Edit user",
        },
        form: {
          name: "Name",
          email: "Email",
          password: "Password",
          profile: "Profile",
          whatsapp: "Default Connection",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        success: "User saved successfully.",
      },
      chat: {
        noTicketMessage: "Select a ticket to start chatting.",
      },
      ticketsManager: {
        buttons: {
          newTicket: "New",
        },
      },
      ticketsQueueSelect: {
        placeholder: "Queues",
      },
      tickets: {
        toasts: {
          deleted: "The ticket you were on has been deleted.",
        },
        notification: {
          message: "Message from",
        },
        tabs: {
          open: { title: "Inbox" },
          closed: { title: "Resolved" },
          search: { title: "Search" },
        },
        search: {
          placeholder: "Search tickets and messages.",
        },
        buttons: {
          showAll: "All",
        },
      },
      transferTicketModal: {
        title: "Transfer Ticket",
        fieldLabel: "Type to search for users",
        fieldQueueLabel: "Transfer to queue",
        fieldConnectionLabel: "Transfer to connection",
        fieldQueuePlaceholder: "Please select a queue",
        fieldConnectionPlaceholder: "Please select a connection",
        noOptions: "No user found with this name",
        buttons: {
          ok: "Transfer",
          cancel: "Cancel",
        },
      },
      ticketsList: {
        pendingHeader: "Queue",
        assignedHeader: "Working on",
        noTicketsTitle: "Nothing here!",
        noTicketsMessage: "No tickets found with this status or search term.",
        connectionTitle: "Connection that is currently being used.",
        buttons: {
          accept: "Accept",
        },
      },
      newTicketModal: {
        title: "Create Ticket",
        fieldLabel: "Type to search for a contact",
        add: "Add",
        connection: "Connection",
        willSendFrom: "Will send from:",
        buttons: {
          ok: "Contact",
          cancel: "Cancel",
        },
      },
      mainDrawer: {
        listItems: {
          dashboard: "Dashboard",
          connections: "Connections",
          tickets: "Tickets",
          contacts: "Contacts",
          quickAnswers: "Quick Answers",
          queues: "Queues",
          automations: "Automations",
          autoReplyRules: "Automations",
          autoReplyRulesShort: "Simple",
          autoReplyFlows: "Advanced Automations",
          autoReplyFlowsShort: "Advanced",
          followUpRules: "Follow-up",
          administration: "Administration",
          users: "Users",
          settings: "Settings",
        },
        appBar: {
          user: {
            profile: "Profile",
            logout: "Logout",
          },
        },
      },
      notifications: {
        noTickets: "No notifications.",
      },
      queues: {
        title: "Queues",
        table: {
          name: "Name",
          color: "Color",
          greeting: "Greeting message",
          actions: "Actions",
        },
        buttons: {
          add: "Add queue",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage:
            "Are you sure? It cannot be reverted! Tickets in this queue will still exist, but will not have any queues assigned.",
        },
      },
      queueSelect: {
        inputLabel: "Queues",
      },
      quickAnswers: {
        title: "Quick Answers",
        table: {
          shortcut: "Shortcut",
          message: "Quick Reply",
          actions: "Actions",
        },
        buttons: {
          add: "Add Quick Reply",
        },
        toasts: {
          deleted: "Quick Reply deleted successfully.",
        },
        searchPlaceholder: "Search...",
        confirmationModal: {
          deleteTitle: "Are you sure you want to delete this Quick Reply: ",
          deleteMessage: "This action cannot be undone.",
        },
      },
      users: {
        title: "Users",
        table: {
          name: "Name",
          email: "Email",
          profile: "Profile",
          whatsapp: "Default Connection",
          actions: "Actions",
        },
        buttons: {
          add: "Add user",
        },
        toasts: {
          deleted: "User deleted sucessfully.",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage:
            "All user data will be lost. Users' open tickets will be moved to queue.",
        },
      },
      settings: {
        success: "Settings saved successfully.",
        title: "Settings",
        settings: {
          userCreation: {
            name: "User creation",
            options: {
              enabled: "Enabled",
              disabled: "Disabled",
            },
          },
        },
      },
      messagesList: {
        header: {
          assignedTo: "Assigned to:",
          buttons: {
            return: "Return",
            resolve: "Resolve",
            reopen: "Reopen",
            accept: "Accept",
          },
        },
      },
      messagesInput: {
        placeholderOpen: "Type a message or press ''/'' to use the registered quick responses",
        placeholderClosed: "Reopen or accept this ticket to send a message.",
        signMessage: "Sign",
      },
      contactDrawer: {
        header: "Contact details",
        buttons: {
          edit: "Edit contact",
        },
        extraInfo: "Other information",
        inkamoney: {
          title: "InkaMoney",
          loading: "Looking up InkaMoney...",
          notFound: "No InkaMoney history",
          error: "Could not reach InkaMoney",
          noDocument: "No code linked to this contact",
          empty: "No information",
          productos: "Products",
          ordenes: "Orders",
          activo: "Active",
          inactivo: "Inactive",
        },
        tabs: {
          info: "Info",
        },
      },
      ticketOptionsMenu: {
        delete: "Delete",
        transfer: "Transfer",
        confirmationModal: {
          title: "Delete ticket #",
          titleFrom: "from contact ",
          message: "Attention! All ticket's related messages will be lost.",
        },
        buttons: {
          delete: "Delete",
          cancel: "Cancel",
        },
      },
      confirmationModal: {
        buttons: {
          confirm: "Ok",
          cancel: "Cancel",
        },
      },
      messageOptionsMenu: {
        delete: "Delete",
        reply: "Reply",
        confirmationModal: {
          title: "Delete message?",
          message: "This action cannot be reverted.",
        },
      },
      backendErrors: {
        ERR_NO_OTHER_WHATSAPP:
          "There must be at lest one default WhatsApp connection.",
        ERR_NO_DEF_WAPP_FOUND:
          "No default WhatsApp found. Check connections page.",
        ERR_WAPP_NOT_INITIALIZED:
          "This WhatsApp session is not initialized. Check connections page.",
        ERR_WAPP_CHECK_CONTACT:
          "Could not check WhatsApp contact. Check connections page.",
        ERR_WAPP_INVALID_CONTACT: "This is not a valid whatsapp number.",
        ERR_WAPP_DOWNLOAD_MEDIA:
          "Could not download media from WhatsApp. Check connections page.",
        ERR_INVALID_CREDENTIALS: "Authentication error. Please try again.",
        ERR_SENDING_WAPP_MSG:
          "Error sending WhatsApp message. Check connections page.",
        ERR_DELETE_WAPP_MSG: "Couldn't delete message from WhatsApp.",
        ERR_OTHER_OPEN_TICKET:
          "There's already an open ticket for this contact.",
        ERR_SESSION_EXPIRED: "Session expired. Please login.",
        ERR_USER_CREATION_DISABLED:
          "User creation was disabled by administrator.",
        ERR_NO_PERMISSION: "You don't have permission to access this resource.",
        ERR_DUPLICATED_CONTACT: "A contact with this number already exists.",
        ERR_NO_SETTING_FOUND: "No setting found with this ID.",
        ERR_NO_CONTACT_FOUND: "No contact found with this ID.",
        ERR_NO_TICKET_FOUND: "No ticket found with this ID.",
        ERR_NO_USER_FOUND: "No user found with this ID.",
        ERR_NO_WAPP_FOUND: "No WhatsApp found with this ID.",
        ERR_CREATING_MESSAGE: "Error while creating message on database.",
        ERR_CREATING_TICKET: "Error while creating ticket on database.",
        ERR_FETCH_WAPP_MSG:
          "Error fetching the message in WhtasApp, maybe it is too old.",
        ERR_QUEUE_COLOR_ALREADY_EXISTS:
          "This color is already in use, pick another one.",
        ERR_WAPP_GREETING_REQUIRED:
          "Greeting message is required if there is more than one queue.",
      },
    },
  },
};

export { messages };
